export default __webpack_public_path__ + "static/media/MWBLES.d734e500.jpg";